/** Board↔lobby relay for envelopes that must reach the peer even when the
 *  board tab has no direct PeerJS link (challenge join via lobby peer id). */
export const LOBBY_GAME_WIRE_TYPES = new Set([
  'dechess-game-action',
  'dechess-game-state',
  'dechess-game-certificate-proposal',
  'dechess-game-certificate-final',
  'dechess-game-vdf-proof',
  'dechess-game-resume-proposal',
  'dechess-game-resume-final'
]);
